/**
 * Traducciones en español para EmptyView
 */

export const emptyViewTranslationsEs = {
  noResults: {
    title: "Oops, parece que tu búsqueda no arrojó ningún resultado...",
    description: "Inténtalo de nuevo modificando los filtros y/o las palabras clave"
  },
  emptyState: {
    title: "¡Vaya! Esta sección está completamente vacía...",
    description: "Aún no hay contenido para mostrar en esta sección. Pronto aparecerán resultados."
  }
};
